import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import Landing from './pages/Landing';
import Search from './pages/Search';
import Checkout from './pages/Checkout';
import './styles/global.css';

// Component to track route changes for ContentSquare
function LocationTracker() {
  const location = useLocation();
  const [isInitial, setIsInitial] = useState(true);

  useEffect(() => {
    if (isInitial) {
      setIsInitial(false);
      return; // Skip first pageview, let CS handle it
    }

    // Track pageview on route change
    window._uxa = window._uxa || [];
    window._uxa.push([
      'trackPageview',
      location.pathname + location.hash.replace('#', '?__')
    ]);
  }, [location, isInitial]);

  return null;
}

function App() {
  return (
    <BookingProvider>
      <BrowserRouter>
        <LocationTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/search" element={<Search />} />
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </BrowserRouter>
    </BookingProvider>
  );
}

export default App;